module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8689/img/cta-blobs.png"